module.exports = "/dist/assets/images/arrow-left-white.svg";